import type { DeliveryAndKlarna as DeliveryAndKlarnaSchema } from '@amplience/content-types/typings/c-delivery-and-klarna';
import { ImagePartial } from '@storefront/lib-global/partials/image';
import { getLocalizedValue } from '@storefront/lib-global/utils/transformers';
import { ComponentItemBar, ComponentList, IconContainer, TextInfo } from './DeliveryAndKlarna.styles';

export type DeliveryAndKlarnaProps = DeliveryAndKlarnaSchema;

export function DeliveryAndKlarna({ deliveryAndKlarnaList }: DeliveryAndKlarnaProps) {
  return (
    <ComponentList>
      {deliveryAndKlarnaList?.map(({ image: imageItem, infoText }, index) => {
        const { altText, assetType, useOriginalSize } = imageItem || {};
        const { name, defaultHost } = imageItem?.image || {};

        return (
          <ComponentItemBar key={name ? `${name}-${index}` : index}>
            <IconContainer>
              {imageItem && (
                <ImagePartial
                  layout="intrinsic"
                  altText={altText}
                  src={name || ''}
                  assetType={assetType}
                  height={24}
                  width={24}
                  defaultHost={defaultHost}
                  useOriginalSize={useOriginalSize}
                />
              )}
            </IconContainer>
            <TextInfo>{getLocalizedValue(infoText?.deliveryAndKlarnaText)}</TextInfo>
          </ComponentItemBar>
        );
      })}
    </ComponentList>
  );
}
